<script lang="ts" setup>
    import { onMounted, ref, watch } from 'vue';
    import ToggleIcon from './ToggleIcon.vue';

    const props = withDefaults(defineProps<{
        panelOpen?: boolean,
        title: string
        }>(), {
        panelOpen: true
    });

    const isPanelOpen = ref(true);

    onMounted(()=>{
        isPanelOpen.value = props.panelOpen;
    });

    const emit = defineEmits(["update:panelOpen"]);

    watch(() => props.panelOpen, (newVal, _oldVal) => {
            isPanelOpen.value = newVal;
    });

</script>

<style scoped>
    .fieldset-border { border: 1px solid grey; border-radius: 0.25em; padding:0.25em }
    legend { font-size:1.25em; float:none; width:auto; margin-left: 0.5em; padding-left: 0.25em; padding-right: 0.25em; margin-bottom: 0px; }
    hr { margin-top:0px; opacity: 1.0; }
</style>

<template>
    <fieldset :class="isPanelOpen ? 'fieldset-border' : ''">
        <legend>
            <ToggleIcon v-model:folded="isPanelOpen" @update:folded="emit('update:panelOpen', isPanelOpen)" :foldedValue="false" />
            {{props.title}}
        </legend>

        <template v-if="isPanelOpen">
            <slot>
            </slot>
        </template>
    </fieldset>
    <hr v-if="!isPanelOpen" />
</template>